import styles from "../../styles/PLMApp.module.css";
// KANBAN VIEW
// src/components/plm/KanbanView.jsx

import { STATUSES, PLM_CATEGORIES } from "../../data/constants";
import { stepDocId } from "../../utils/utils";
// ─────────────────────────────────────────────
export default function KanbanView({ steps, onOpenStep, supplierId }) {
  const grouped = {};
  STATUSES.forEach((s) => {
    grouped[s.key] = [];
  });

  PLM_CATEGORIES.forEach((cat) => {
    cat.steps.forEach((title, i) => {
      const docId = stepDocId(supplierId, cat.id, i);
      const step = steps[docId] || { status: "not_started" };
      const status = step.status || "not_started";
      grouped[status].push({ docId, title, category: cat.name, ...step });
    });
  });

  const colColors = {
    not_started: "var(--status-not-started-text)",
    in_progress: "var(--status-in-progress-text)",
    waiting: "var(--status-waiting-text)",
    blocked: "var(--status-blocked-text)",
    done: "var(--status-done-text)",
  };

  return (
    <div style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
      <div className={styles.kanbanBoard}>
        {STATUSES.map((s) => (
          <div key={s.key} className={styles.kanbanCol}>
            <div className={styles.kanbanColHeader}>
              <span
                className={styles.kanbanColTitle}
                style={{ color: colColors[s.key] }}
              >
                {s.label}
              </span>
              <span className={styles.kanbanColCount}>
                {grouped[s.key].length}
              </span>
            </div>
            <div className={styles.kanbanCards}>
              {grouped[s.key].map((step) => (
                <div
                  key={step.docId}
                  className={styles.kanbanCard}
                  onClick={() => onOpenStep(step.docId, null)}
                >
                  <div className={styles.kanbanCardTitle}>
                    {step.title || step.stepTitle}
                  </div>
                  <div className={styles.kanbanCardCategory}>
                    {step.category}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
